import 'twin.macro';
import React, { RefObject } from 'react';
import AutoSuggestGroup from '@teetsh/app/src/components/Form/AutoSuggestGroup';
import { Material } from '@teetsh/app/src/types/event';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useUpdateUser from '@teetsh/app/src/queries/user/useUpdateUser';
import { v4 as uuid } from 'uuid';
import { useTranslation } from 'react-i18next';
import {
  ArrowTopRightOnSquareIcon,
  PlusIcon,
} from '@heroicons/react/24/outline';
import ButtonExternal from 'components/Buttons/ExternalLink';
import Button from 'components/Buttons/Button';

interface Props {
  items: Material[];
  onChange: (v: Material[]) => void;
  inputRef?: RefObject<HTMLInputElement>;
  enableEdit: boolean;
}

export default function MaterialItems(props: Props) {
  const { items = [], onChange, inputRef, enableEdit } = props;
  const user = useUser();
  const updateUser = useUpdateUser();
  const handleSaveMaterial = (value: string) =>
    updateUser({ ...user, materials: [...user.materials, value] });
  const userMaterials = user.materials || [];
  const { t } = useTranslation(['common']);
  return (
    <>
      <AutoSuggestGroup
        items={items}
        onChange={onChange}
        inputRef={inputRef}
        onSave={enableEdit ? handleSaveMaterial : undefined}
        options={userMaterials.map(v => ({ value: v, label: v }))}
        placeholder={t('common:components.materials.placeholder')}
        singleValue
      />
      {enableEdit && (
        <div tw="mt-2 flex gap-2">
          <Button
            small
            onClick={() => {
              onChange([...items, { value: '', id: uuid() }]);
              setTimeout(() => {
                inputRef?.current?.focus();
              }, 1);
            }}
            icon={PlusIcon}
          >
            {t('common:components.materials.addMaterial')}
          </Button>
          <ButtonExternal
            href="/settings/materials"
            small
            icon={ArrowTopRightOnSquareIcon}
            tw="text-center"
          >
            {t('common:components.materials.accessList')}
          </ButtonExternal>
        </div>
      )}
    </>
  );
}
